<template>
    <div class="loading-warp">
        <div class="loading-box">
            <div></div>
            <h1>{{ titleText }}</h1>
            <p v-if="companyText"><span>{{ companyText }}</span></p>
        </div>
    </div>
</template>
<script>
import "@/utils/flexible";

// 兜底文案（接口未就绪前使用）：公司标识 => 落款文案
const COMPANY_TEXT = {
    jf: "本服务由巨丰投资资讯有限公司提供并承担法律责任", // 巨丰
    zf: "本服务由中富金石咨询有限公司提供并承担法律责任", // 中富金石
};

export default {
    name: "",
    props: {
        /**
         * 组件方式引入时，由父组件传入公司标识：jf=巨丰、zf=中富金石
         * 不传值则只展示加载中，不展示落款文案
         */
        company: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            // 公司标识：路由进入时取 url 上的 company 参数，组件引入时取 props
            companyKey: "",
            // 当前实例是否由 <router-view> 渲染（路由进入）
            isRoutePage: false,
            // 落款文案，为空则只展示「加载中...」
            companyText: "",
            // 标题文案，为空则按 companyText 兜底
            companyTitle: "",
        };
    },
    computed: {
        titleText() {
            if (this.companyTitle) {
                return this.companyTitle;
            }
            return this.companyText ? "即将进入投顾公司页面..." : "加载中...";
        },
    },
    watch: {
        // 父组件异步传值时同步更新
        company(val) {
            this.setCompanyKey(val);
        },
    },
    created() {
        // router-view 渲染的子组件 vnode 上会带 routerView 标记，以此区分两种引入方式
        this.isRoutePage = !!(this.$vnode && this.$vnode.data && this.$vnode.data.routerView);
        this.setCompanyKey(this.company);
    },
    methods: {
        setCompanyKey(val) {
            let key = val;
            if (!key && this.isRoutePage && this.$route && this.$route.query) {
                key = this.$route.query.company;
            }
            this.companyKey = key ? String(key).trim().toLowerCase() : "";
            this.getCompanyInfo();
        },
        /**
         * 展示与否、展示什么文案，后续由接口控制
         * 期望返回结构（字段名以接口为准）：{ is_show: Boolean, text: String, title: String }
         */
        async getCompanyInfo() {
            const res = await this.fetchCompanyInfo();
            if (!res) {
                // 接口未就绪，先走本地兜底映射
                this.companyText = COMPANY_TEXT[this.companyKey] || "";
                this.companyTitle = "";
                return;
            }
            this.companyText = res.is_show ? res.text || "" : "";
            this.companyTitle = this.companyText ? res.title || "" : "";
        },
        /** TODO 接口占位，接口就绪后在此发起请求，如 api.getLoadingTip({ company: this.companyKey }) */
        async fetchCompanyInfo() {
            return null;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.loading-warp {
    padding-top: 10px;
    background: $a-white;
    width: 100%;
    min-height: 100vh;

    .loading-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: $a-lfff-d121212;
        padding: 186px 0;
        box-sizing: border-box;

        div {
            background-image: url("https://cdncos.aigupiao.com/assets/app/svg/loading.svg");
            background-size: 60px;
            background-position: center;
            background-repeat: no-repeat;
            width: 60px;
            height: 60px;
            animation: rotateDom .8s linear infinite;
        }

        h1 {
            margin-top: 30px;
            font-size: 16px;
            line-height: 22px;
            color: $a-dl-f3-3;
        }

        p {
            margin-top: 30px;
            font-size: 14px;
            line-height: 18px;
            color: $a-l999-d888;
        }
    }
}

@keyframes rotateDom {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>